import { createContext } from 'react'

export type OnboardingContextType = {
  stepIndex?: number
  setStepIndex?: (stepIndex: number) => void

  onboardingMode?: boolean
  setOnboardingMode?: (value: boolean) => void
}

export const OnboardingContext = createContext<OnboardingContextType>({
  stepIndex: 0,
  setStepIndex: () => {},
  onboardingMode: false,
  setOnboardingMode: () => {},
})
